"use client";

import React from "react";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Link } from "@/components/common/Link";
const wp_query_params = {
  per_page: 8,
  orderby: "popularity"
};
const wp_query = new WP_Query(wp_query_params);
function ProductsCarouselConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="222627" className="flex gap-4 overflow-hidden">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/4 shrink-0">
            <div className="aspect-[4/5] bg-muted/20 animate-pulse rounded-none mb-4" />
            <div className="h-6 bg-muted/20 animate-pulse w-3/4 mx-auto mb-2" />
            <div className="h-4 bg-muted/20 animate-pulse w-1/4 mx-auto" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-destructive py-8 font-default">
        An error occurred while loading the items.
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="text-center text-muted-foreground py-8 font-default">
        No promotional items are currently available.
      </div>;
  }
  return <Carousel opts={{
    align: "start",
    loop: true
  }} className="w-full">
      <CarouselContent className="-ml-4">
        {products.map((product, i) => <CarouselItem key={product.id} data-index={i} className="pl-4 basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/4">
            <div className="group relative flex flex-col h-full bg-secondary/30 backdrop-blur-md border border-white/10 rounded-md transition-all duration-300 hover:border-primary/50">
              <div className="relative overflow-hidden aspect-[4/5] bg-muted/10">
                <Link to={product.link} className="block w-full h-full">
                  {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-secondary text-secondary-foreground">
                      <span className="font-default text-xs uppercase tracking-widest">Empty</span>
                    </div>}
                </Link>
                <div className="absolute bottom-4 right-4 z-10 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-primary text-primary-foreground shadow-[0_0_15px_rgba(59,130,246,0.5)] hover:bg-primary/90 px-5 py-2 rounded-sm text-xs font-bold uppercase tracking-widest transition-all" text="Buy Now" showQuantity={false} />
                </div>
              </div>
              <div className="pt-5 pb-4 text-center flex flex-col grow justify-between px-4">
                <Link to={product.link}>
                  <h3 className="font-default text-lg font-bold text-foreground mb-2 line-clamp-1 uppercase tracking-tight">
                    {product.title}
                  </h3>
                </Link>
                <p className="font-mono text-base font-bold text-accent-foreground">
                  ${product.price?.toFixed(2) || "0.00"}
                </p>
              </div>
            </div>
          </CarouselItem>)}
      </CarouselContent>
      <div className="flex items-center justify-center gap-4 mt-10">
        <CarouselPrevious className="static translate-y-0 translate-x-0 bg-secondary border-white/10 text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors" />
        <CarouselNext className="static translate-y-0 translate-x-0 bg-secondary border-white/10 text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors" />
      </div>
    </Carousel>;
}
export default function FloresDestacadas() {
  return;
}